import { z } from 'zod';

/** Сводка дня по проекту / объекту (ПР-12, ПФ-06): цифры из отчётов смены, текст — шаблон (ИИ позже). */
export const SiteDaySummaryQuery = z.strictObject({
  projectId: z.uuid(),
  date: z.iso.date().optional(),
  objectId: z.uuid().optional(),
});
export type SiteDaySummaryQuery = z.infer<typeof SiteDaySummaryQuery>;

export interface SiteDaySummaryReport {
  id: string;
  packageId: string;
  packageName: string;
  authorId: string;
  authorName: string;
  state: string;
  /** Снимки (kind=photo или без kind в старых черновиках). */
  photoCount: number;
  /** Короткие ролики (kind=video). */
  videoCount: number;
  lineCount: number;
  objectId: string | null;
}

export interface SiteDaySummaryLabor {
  profession: string;
  headcount: number;
  hours: string;
  idleHours: string;
}

export interface SiteDaySummaryMachine {
  machineId: string;
  name: string;
  hours: string;
  idleHours: string;
}

export interface SiteDaySummaryRemark {
  id: string;
  number: string;
  title: string;
  source: string;
  status: string;
  dueDate: string;
  overdue: boolean;
  stopWork: boolean;
}

/** Вызов на освидетельствование скрытых работ (АОСР), ещё без решения надзора */
export interface SiteDaySummaryInspection {
  id: string;
  number: string;
  workName: string;
  /** Когда вызваны, ISO */
  scheduledAt: string;
  /** Дата вызова раньше даты сводки — надзор не приехал или не подписал */
  overdue: boolean;
  /** Какая работа графика ждёт акта */
  nextActivityName: string | null;
}

export interface SiteDaySummaryDelay {
  activityId: string;
  code: string;
  name: string;
  plannedFinish: string;
  percent: number;
  critical: boolean;
}

export interface SiteDaySummaryMissing {
  packageId: string;
  packageName: string;
  foremanName: string | null;
}

export interface SiteDaySummary {
  date: string;
  projectId: string;
  projectCode: string;
  projectName: string;
  objectId: string | null;
  objectName: string | null;
  reports: SiteDaySummaryReport[];
  labor: SiteDaySummaryLabor[];
  machines: SiteDaySummaryMachine[];
  photoCount: number;
  videoCount: number;
  remarks: SiteDaySummaryRemark[] | null;
  /** Вызовы на освидетельствование на дату и ближайшие 7 дней; только тем, кто видит надзор */
  inspections: SiteDaySummaryInspection[] | null;
  delays: SiteDaySummaryDelay[];
  missing: SiteDaySummaryMissing[];
  /** Краткий текст сводки; сейчас из цифр, позже — Pilot */
  text: string;
  textSource: 'template' | 'pilot';
}

/** Сводка численности и техники по подрядчикам за период (ПР-19) */
export const SiteCrewSummaryQuery = z.strictObject({
  from: z.iso.date(),
  to: z.iso.date(),
});
export type SiteCrewSummaryQuery = z.infer<typeof SiteCrewSummaryQuery>;

export interface SiteCrewSummary {
  projectId: string;
  projectCode: string;
  projectName: string;
  from: string;
  to: string;
  reportCount: number;
  contractors: Array<{
    contractorId: string | null;
    contractorName: string;
    labor: Array<{ profession: string; headcount: number; hours: string; idleHours: string }>;
    machines: Array<{ machineId: string; name: string; hours: string; idleHours: string }>;
  }>;
}
